import React from 'react';
import get from 'lodash/get'
import Helmet from 'react-helmet'
import {
    Col,
    Grid,
    Row
} from 'react-flexbox-grid';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography'
import Moment from 'react-moment'
import {Link} from 'react-router-dom'

import PageTitle from '../../components/page-title'
import HorizontalCard from '../../components/horizontal-card';
import SocialShare from '../../components/social-share';

import smartphone_icon from './smartphone.svg';
import sheets_icon from './sheets.svg';

import press_json from './press.json';

export default class InitiativesPage extends React.Component{
    render(){
	const siteTitle = get(this.props, 'data.site.siteMetadata.title');
	let press_data = press_json.data;
	
	var media_kit = [
	    {
		title: "Fact Sheet",
		icon: sheets_icon,
		body: <p>What to know about us<br /><a href='/assets/pdf/share_meals_fact_sheet.pdf' target='_blank'>Download (pdf)</a></p>
	    },
	    {
		title: "App Overview",
	    icon: smartphone_icon,
	    body: <p>How the <strong>Share Meals App</strong> works<br /><a href='/assets/pdf/share_meals_app_overview.pdf' target='_blank'>Download (pdf)</a></p>
	    },
	    {
		title: "Share on Social Media",
	    icon: null,
		body: <span>
		    <p>
			Use these buttons to share about us on your social networks
		    </p>
		    <SocialShare></SocialShare>
		</span>
	    }

	];


	// <Moment date={press.date} format="MMMM Do, YYYY"/>
	return [
		<PageTitle 
			titles={{
				title: "Recent News"
			}}
		/>,
	    <Grid style={{paddingBottom: '3rem'}}>
		<Helmet
		    title={`Press | ${siteTitle}`}
		/>
		<div className="section slim">

		{press_data.map(function(press, index){
		     return(
			 <Row style={{marginTop: '1rem'}}
			      key={index}>
			     <Col xs={12} lg={8} lgOffset={2}>
				 <Card className="card white">
				     <CardContent>
					 <Typography variant="headline" className="title">
					     {press.title}
					 </Typography>
					 <Typography variant="subheading">
					     <strong>{press.where}</strong>, {press.date} <a href={press.link} target="_blank">link</a>
					 </Typography>
				     </CardContent>
				 </Card>
			     </Col>
			 </Row>
		     )
		 })}
		</div>
		<div className="section">
		
		<Row>
		    <Col xs>
			<h2 className="title" style={{textAlign: 'center'}}>
			    Media Kit
			</h2>
		    </Col>
		</Row>
		<Row>
		    {media_kit.map(function(media, index){
			 return(
			     <Col xs={10} xsOffset={1}
				  sm={8} smOffset={2}
				  md={6} mdOffset={0}
				  lg={4}
				  key={index}
				  style={{marginTop: '1rem'}}>
				 <HorizontalCard
				     title={media.title}
				     image={media.icon}
				     imagePadding={32}>
				     {media.body}
				 </HorizontalCard>
			     </Col>
			 )})}
		</Row>
		</div>
	    </Grid>
	    
	];
    }
}

export const pressQuery = graphql`
    query pressQuery{
	site {
	    siteMetadata {
		title
	    }
	}
    }
`



// WEBPACK FOOTER //
// ./src/pages/press/index.js